const React = require('react');
const { map, capitalize, isEmpty } = require('lodash');
const Immutable = require('immutable');

// @ utilities
const { addOrdinal } = require('utilities/stringHelper');
const { getLanguage } = require('core/i18n').i18n;

// @ components
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKLink } = require('commonsComponents/OKLink');
const { OKIconButton } = require('commonsComponents/OKIconButton');
const MortgageRequestFormattedAddress = require('./mortgageRequestEstatesData/mortgageRequestFormattedAddress/mortgageRequestFormattedAddress');

// @ constants
const { text, dataTypes } = require('./initialValues');
const { ESTATES_TYPE_ABBREVIATION } = require('constants/mortgageRequestEstates');

// @ utilities
const { recordProcess, PROC_CANCEL } = require('utilities/tagging');

// @ track processes
const { PROC_ADD_ESTATES_DATA } = require('constants/mortgageRequestProcesses');

const handleCancelAddEstates = () => {
    recordProcess(PROC_ADD_ESTATES_DATA, PROC_CANCEL);
};

const formatAddress = (addressData, anotherState = false, hasNSResult) => {

    if (addressData.idType === dataTypes.ADDRESS || (!anotherState && addressData.idType !== dataTypes.ADDRESS)) {
        return (
            <div className="row">
                <div className="col-xs-12">
                    <span className="mortgage-request-estates__info-page">
                        {text().INFO_PAGE.ADDRESS}
                    </span>
                    <p className="mortgage-request-estates__info-page-paragraph">
                        <MortgageRequestFormattedAddress
                            immEstate={Immutable.fromJS(addressData)}
                            className="mortgage-request-estates__info-page-paragraph"
                            compact={!hasNSResult}
                        />
                    </p>
                </div>
            </div>
        );
    }

    return '';
};

const formatRegistralData = (estate, hasTitle = false) => {
    if (estate.registerData) {
        const textValue = text();
        const title = hasTitle && (
            <div className="col-xs-12">
                <h5>
                    {textValue.ANOTHER_ESTATES.ADDITIONAL.OPTIONS.REG_DATA}
                </h5>
                <br />
            </div>
        );

        const textInfo = {
            [textValue.LABEL.PROVINCE]: `${estate.provinceData.label}, `,
            [textValue.LABEL.POPULATION]: `${estate.populationData.label}, `,
            [textValue.LABEL.REGISTER_NAME]: `${estate.registerData.label}, `,
            [textValue.LABEL.ESTATE_NUMBER]: `${estate.registerFincaNumber}, `,
            [textValue.LABEL.SECTION]: `${estate.registerSection}, `,
            [textValue.LABEL.BOOK]: `${estate.registerBook}, `,
            [textValue.LABEL.VOLUME]: `${estate.registerVolume}, `,
            [textValue.LABEL.FOLIO]: `${estate.registerFolio}, `
        };

        const textHtml = map(textInfo, (value, param) => <span key={param}>{param}: {value} </span>);

        return (
            <div className="row">
                {title}
                <div className="col-xs-8">
                    <p className="mortgage-request-estates__info-page-paragraph">
                        {textHtml}
                    </p>
                </div>
            </div>
        );
    }
    return '';
};

const formatIdufir = (idufir, hasTitle = false) => {
    if (idufir) {
        const title = hasTitle && (
            <div className="row">
                <div className="col-xs-12">
                    <h5>
                        {text().ANOTHER_ESTATES.ADDITIONAL.OPTIONS.CRU}
                    </h5>
                </div>
            </div>
        );

        return (
            <div className="row">
                <div className="col-xs-12">
                    {title}
                    <div className="row">
                        <div className="col-xs-12">
                            <p className="mortgage-request-estates__info-page-paragraph">
                                {idufir}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    return '';
};

const buildIncludedEstatesInfo = addressData => {
    const { storageRooms, garages } = addressData;
    const textValue = text();
    const { STORAGE_ROOM, STORAGE_ROOMS } = textValue.LABEL;
    const { GARAGE, GARAGES } = textValue.INFO_PAGE;

    if (garages > 0 || storageRooms > 0) {
        const storageRoomsLabel = capitalize(storageRooms > 1 ? STORAGE_ROOMS : STORAGE_ROOM);
        const garagesLabel = capitalize(garages > 1 ? GARAGES : GARAGE);

        const storageRoomsHtml = storageRooms > 0 ? `${storageRooms} ${storageRoomsLabel}` : '';
        const garagesHtml = garages > 0 ? `${garages} ${garagesLabel}` : '';

        return (
            <div className="row">
                <div className="col-xs-12">
                    <h5>{textValue.INFO_PAGE.INCLUDED_ESTATES}</h5>
                    <br />
                    <p className="mortgage-request-estates__info-page-paragraph">{storageRoomsHtml}</p>
                    <p className="mortgage-request-estates__info-page-paragraph">{garagesHtml}</p>
                </div>
            </div>
        );
    }
};

const livingPlaceAddress = (addressData, hasNSResult) => {
    const includedEstatesHtml = buildIncludedEstatesInfo(addressData);
    const textValue = text();
    return (
        <div className="col-xs-12">
            <OKBoxTitle
                value={textValue.INFO_PAGE.LIVING_DATA}
                isNotSeparator={true}
            />
            <div className="row mortgage-request-estates__info-page-section">
                <div className="col-xs-12">
                    <br />
                    <br />
                    {formatAddress(addressData, false, hasNSResult)}
                    {formatIdufir(addressData.idufir, true)}
                    {formatRegistralData(addressData, true)}
                </div>
            </div>
            <div className="row mortgage-request-estates__info-page-section">
                <div className="col-xs-12">
                    {includedEstatesHtml}
                    <br />
                    <br />
                </div>
            </div>

        </div>
    )
};

const buildAnotherEstatesInfo = (idx, estate, hasNSResult) => {
    const ordinal = addOrdinal(getLanguage(), idx + 1);
    const textValue = text();
    const estateType = capitalize(estate.propertyType === ESTATES_TYPE_ABBREVIATION.GARAJE ? textValue.LABEL.GARAGE : textValue.LABEL.STORAGE_ROOM);

    return (
        <div className="row" key={idx}>
            <div className="col-xs-12">
                <h5>{ordinal} {estateType} {textValue.INFO_PAGE.ANOTHER_ESTATES_NOTE}</h5>
                <br />
                {formatAddress(estate, true, hasNSResult)}
                {formatIdufir(estate.idufir)}
                {formatRegistralData(estate)}
            </div>
        </div>
    )
};

const anotherEstates = (addressData, anotherEstatesData, hasNSResult) => {
    const { storageRooms, garages } = anotherEstatesData;
    const textValue = text();
    if (isEmpty(storageRooms) && isEmpty(garages)) {
        return '';
    }

    const anotherEstatesStorageHtml = map(storageRooms, (estate, idx) => buildAnotherEstatesInfo(idx, estate, hasNSResult));
    const anotherEstatesGaragesHtml = map(garages, (estate, idx) => buildAnotherEstatesInfo(idx, estate, hasNSResult));

    return (
        <div className="col-xs-12">
            <OKBoxTitle
                value={textValue.INFO_PAGE.ANOTHER_ESTATES}
                isNotSeparator={true}
            />
            <div className="row mortgage-request-estates__info-page-section">
                <div className="col-xs-12">
                    {anotherEstatesStorageHtml}
                    {anotherEstatesGaragesHtml}
                </div>
            </div>
        </div>
    )
};

const infoPage = (addressData, anotherEstatesData, handleEdit, hasNSResult) => {
    const textValue = text();
    return (
        <div className="mortgage-request-estates__info-page">
            <div className="row">
                <div className="col-xs-12">
                    <h2>{textValue.TITLE}</h2>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-11">
                    <h3>{textValue.INFO_PAGE.TEXT_1}</h3>
                </div>
                <div className="col-xs-1">
                    <div className="pull-right">
                        <OKIconButton
                            icon="icon-editar"
                            id="btnEditId"
                            onClick={handleEdit}
                        />
                    </div>
                </div>
            </div>
            <div className="row">
                {livingPlaceAddress(addressData, hasNSResult)}
            </div>
            <div className="row">
                {anotherEstates(addressData, anotherEstatesData, hasNSResult)}
            </div>

            <div className="row">
                <div className="col-xs-12">
                    <hr />
                </div>
            </div>

            <div className="row">
                <div className="col-xs-12">
                    <OKLink
                        to="myprofile/mortgage/panel"
                        className="ok-link"
                        onClick={handleCancelAddEstates}
                    >
                        {textValue.LABEL.BACK}
                    </OKLink>
                </div>
            </div>

        </div>
    )
};

module.exports = infoPage;
